<!-- eslint-disable import/no-unresolved -->
<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

import { usePollenStore } from '@/stores/pollen_store';

import UserAccount from './Account/UserAccount.vue';
import UserPasskeys from './Account/UserPasskeys.vue';
import UserRecoveryKit from './Account/UserRecoveryKit.vue';
import UserSecretKey from './Account/UserSecretKey.vue';
import Unlock from './AuthForms/Unlock.vue';
import UnlockSecret from './AuthForms/UnlockSecret.vue';
import type { User } from './types';

const pollenStore = usePollenStore();
const { isLocked, isLoggedInWithoutSecret } = storeToRefs(pollenStore);

const user = computed(() => {
  return {
    email: pollenStore.email,
    account: {
      appsInstalled: pollenStore.deployments.length,
      secretKey: pollenStore.formattedSecretKey,
    },
  } as User;
});
</script>

<template>
  <div class="settings-columns">
    <Unlock v-if="isLocked" />
    <UnlockSecret v-else-if="!isLocked && isLoggedInWithoutSecret" />
    <div class="row">
      <div class="grid__col-md-6">
        <UserAccount v-if="!isLocked" :user="user" />
      </div>
      <div class="grid__col-md-6">
        <UserRecoveryKit v-if="!isLocked && user.account.secretKey" />
      </div>
    </div>
    <div class="row settings-columns__passkeys">
      <div class="grid__col-md-12">
        <UserPasskeys v-if="!isLocked" />
      </div>
    </div>
  </div>

  <UserSecretKey v-if="!isLocked && user.account.secretKey" :secret-key="user.account.secretKey" />
</template>

<style lang="scss" scoped>
@use '@clovyr/bed/styles/vendor/bootstrap/scss/bootstrap';
@use '@clovyr/bed/styles/core';
@use 'src/styles/core/page';
@use 'src/styles/core/vertical-spacing';
@use 'styles/core/colors';
@use 'styles/core/layout/grid-vars';
@use 'styles/vendor/bootstrap/scss/mixins/breakpoints';

$padding: grid-vars.space(3.6);

.settings-columns {
  margin-bottom: 1rem;
  color: colors.color(white);

  .row {
    --cl-gutter-x: 1rem;

    padding-left: 0;
    padding-right: 0;

    [class*='grid__col'] {
      &:not(:first-child) {
        margin-top: grid-vars.space(1.7);

        @include breakpoints.media-breakpoint-up(md) {
          margin-top: 0;
        }
      }
    }
  }

  :deep(.no-key-message) {
    margin: 0 0 2rem 0;
    background: #3c3554;
  }

  &__passkeys {
    margin-top: 1rem;
  }
}
</style>
